import styled from "styled-components";
import FlagEng from "./FlagEng";
import FlagSwe from "./FlagSwe";

const FlagContainer = styled.div`
  transform: scale(0.5) translate(50%, -50%);
  position: absolute;
  right: 0.3em;
  top: 0.3em;
  z-index: 2;
`;

const Flags = () => (
  <FlagContainer>
    <FlagSwe /> <FlagEng />
  </FlagContainer>
);

export default Flags;
